import {
  getBrandTableColumn,
  getProjectTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      {
        field: 'sku',
        title: 'SKU/ID',
        sortable: true,
        slots: {
          default: ({ row }) => {
            return [
              <div class='text-truncate'>
                <list-body-cell-wrap copy row={ row } field='sku' title={ row.sku } />
                <list-body-cell-wrap copy row={ row } field='sku_id' hideField title={ row.sku_id } message={ row.sku_id.toString() } ><span style="color: #999;">{ row.sku_id }</span></list-body-cell-wrap>
              </div>,
            ]
          },
        },
      },
      getBrandTableColumn({ field: 'provider' }),
      getProjectTableColumn({ hidden: this.$store.getters.isProjectMode, minWidth: 'auto', field: 'sku_service' }),
      {
        field: 'quantity',
        title: i18n.t('bill.text_110'),
        formatter: ({ row }) => numerify(row.quantity, '0,0.00'),
      },
      {
        field: 'unit',
        title: i18n.t('bill.text_111'),
      },
      getTimeTableColumn({ field: 'used_at', title: '日期' }),
      {
        field: 'trans_subtotal',
        title: i18n.t('op_100'),
        sortable: true,
        align: 'right',
        headerAlign: 'right',
        slots: {
          default: ({ row }) => {
            const money = numerify(row.trans_subtotal, '0,0.00')
            return [<list-body-cell-wrap copy row={ row } field='trans_subtotal' hideField title={ row.trans_subtotal } message={ row.trans_subtotal.toString() }><div class="text-right">{this.currencySign}{ money }</div></list-body-cell-wrap>]
          },
        },
      },
    ]
  },
}
